import React, { useEffect, useState } from "react";
// @ts-ignore No type definition for loader.gif
import loaderGif from "./images/loader.gif";

interface ImageWithLoaderProps
  extends React.ImgHTMLAttributes<HTMLImageElement> {
  placeholderColor?: string;
  placeholderWidth?: number;
  placeholderHeight?: number;
  loaderTimeout?: number;
}

// Note: This can be moved to a utils or common folder
export const ImageWithLoader: React.FC<ImageWithLoaderProps> = ({
  placeholderColor = "lightgray",
  placeholderWidth,
  placeholderHeight,
  style,
  onLoad: propsOnLoad,
  loaderTimeout = 5000,
  ...imgProps
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [showLoader, setShowLoader] = useState(true);
  const [hasError, setHasError] = useState(false);

  // Hide the loader gif if it doesn't load within 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, loaderTimeout);
    return () => clearTimeout(timer);
  }, [loaderTimeout]);

  const handleLoad = (event: React.SyntheticEvent<HTMLImageElement>) => {
    setIsLoading(false);
    propsOnLoad?.(event);
  };

  const handleError = (event: React.SyntheticEvent<HTMLImageElement>) => {
    setHasError(true);
    setIsLoading(false);
  };

  return (
    <div
      className="image-with-loader"
      role="img"
      aria-label={imgProps.alt || "Image"}
    >
      {isLoading && (
        <div
          className="image-thumbnail-placeholder"
          role="presentation"
          aria-hidden="true"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: placeholderWidth,
            height: placeholderHeight,
            backgroundColor: placeholderColor
          }}
        >
          {showLoader && (
            <img
              src={loaderGif}
              alt="loader"
              className="loader-gif"
              aria-live="polite"
            />
          )}
        </div>
      )}
      <img
        {...imgProps}
        style={{
          ...style,
          opacity: isLoading ? 0 : 1,
          transition: "opacity 0.2s ease-in-out"
        }}
        onLoad={handleLoad}
        onError={handleError}
      />

      {hasError && (
        <div
          className="image-error-placeholder"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: placeholderWidth,
            height: placeholderHeight,
            backgroundColor: placeholderColor,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <span></span>
        </div>
      )}
    </div>
  );
};
